export default {
  AVATAR: 'avatar',
  IMAGE: 'image',
  BUTTON: 'button',
  BRANDING_LOGO: 'branding_logo',
};
